import recipeIdeas_0 from "../../images/projects/recipeIdeas/0.PNG";
import recipeIdeas_1 from "../../images/projects/recipeIdeas/1.PNG";
import recipeIdeas_2 from "../../images/projects/recipeIdeas/2.PNG";
import recipeIdeas_3 from "../../images/projects/recipeIdeas/3.PNG";
import recipeIdeas_4 from "../../images/projects/recipeIdeas/4.PNG";
import recipeIdeas_5 from "../../images/projects/recipeIdeas/5.PNG";
import recipeIdeas_6 from "../../images/projects/recipeIdeas/6.PNG";
import recipeIdeas_7 from "../../images/projects/recipeIdeas/7.PNG";
import recipeIdeas_8 from "../../images/projects/recipeIdeas/8.PNG";

export default function recipeIdeasImages() {
  return [
    recipeIdeas_0,
    recipeIdeas_1,
    recipeIdeas_2,
    recipeIdeas_3,
    recipeIdeas_4,
    recipeIdeas_5,
    recipeIdeas_6,
    recipeIdeas_7,
    recipeIdeas_8,
  ];
}
